import { type FeatureFlags } from "./features";

export function getRuntimeConfig() {
  return {
    features: {
      recommendations: window.RECO_FRONTEND_CONFIG?.ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_RECOMMENDATIONS,
      sereca: window.RECO_FRONTEND_CONFIG?.ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_SERECA,
      comparisons: window.RECO_FRONTEND_CONFIG?.ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_COMPARISONS,
      criteo: window.RECO_FRONTEND_CONFIG?.ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_CRITEO,
      shopAsst: window.RECO_FRONTEND_CONFIG?.ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_SHOP_ASST,
      dynamicPdpRecos: window.RECO_FRONTEND_CONFIG?.ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_DYNAMIC_PDP_RECO,
    } satisfies FeatureFlags,
    criteoPartnerIds: window.RECO_FRONTEND_CONFIG?.ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_CRITEO_PARTNER_IDS,
  };
}

declare global {
  interface Window {
    RECO_FRONTEND_CONFIG?: {
      ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_RECOMMENDATIONS: string;
      ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_SERECA: string;
      ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_COMPARISONS: string;
      ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_CRITEO: string;
      ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_SHOP_ASST: string;
      ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_CRITEO_PARTNER_IDS: string;
      ODJ_DEP_RECO_FRONTEND_VARS_PUBLIC_DYNAMIC_PDP_RECO: string;
    };
  }
}
